import { api } from './client'
import type {
  LoginRequest, LoginResponse, RefreshResponse, DashboardSummary, FinancialAccount, PreviaSaldoAbertura, SaldoAberturaRequest, ResultadoSaldoAbertura,
  FinancialTransaction, FinancialTransactionHistory, FinancialGoal, OpenFinanceConnection,
  ContaPluggyInfo, TransacaoPluggyInfo, PluggyCredencialInfo, CursorResultInfo,
  PluggyVinculoInfo, RegistrarItemResultado, PreviaExcluirDuplicadaInfo, ExcluirDuplicadaResultadoInfo, ConfiguracaoVinculoInfo, ConfigurarVinculoRequest, ResumoConfiguracaoInfo, PreviaConfiguracaoInfo, ResumoRefazerInfo, RefazerRequest, ResultadoRefazerInfo, PluggyPendenciaInfo, PluggyHistoricoItemInfo, PluggyCategoriaMapeamentoInfo, CandidatoFusaoInfo, CompraCandidataEstorno,
  RegraCategorizacao, SalvarRegraCategorizacao,
  UsuarioItem, FiltroUsuarios, PagedResult,
  Categoria, RemocaoCategoria, TagItem, RecurringTransaction, OcorrenciaRecorrencia, RenegociacaoRecorrencia, LiquidoOcorrencia,
  CreditCard, RecargaAutomatica, Fatura, Orcamento, OrcamentoResumo, Projecao, EntradaSimulada, CompraSimulada, ConviteOrcamento, PessoaRelacionada, AlertaConfig,
  RelatorioCategorias, RelatorioMesItem, RelatorioProjecaoItem, Comparativo, ComparativoLancamentos, RelatorioCategoriaHistorico,
  OrcamentoHistorico, MetaSnapshot,
  PatrimonioHistorico, AssinaturaDetectada, ParcelasFuturas, QualidadeCategorizacao,
  Compartilhamento, ContextoCompartilhado, Permissoes, Notificacao,
  CartaoUtilizavel, CriarCompraDivididaRequest, CompraDividida,
  GrupoItem, SalvarGrupoItemRequest, GrupoDetalhe, ItemSemGrupo, ReprocessarHistoricoResultado, EssencialOpcional,
  GrupoSugerido, CriarGruposSugeridosRequest, CriarGruposSugeridosResultado,
  ListaComprasResumo, ListaCompras, AdicionarItemListaRequest, ConciliacaoLista, AplicarConciliacaoRequest, InsightsNota, ParteCompraRequest,
  NotaFiscal, NotaItemEntrada, LancamentoCandidato, ItemCompradoGrupo, ResumoItens, CatalogoItens, GestaoItens, ConfiguracaoItens, SugestoesCompra, SugestaoLimite, TipoMarcaRecorrencia, LancamentosDoOrcamento, CompraCartaoResultado, FaturaResumo, ItemPreVisualizacaoCsv, ResultadoImportacaoCsv, ExclusaoComEscopo, DecisaoPar, DivergenciasCsv, DestinoSugeridoCsv, PagarFaturaResultado, PagamentoJaImportado, FaturaCategorias,
  PublicacaoImportacaoPdf, StatusImportacaoPdfJob, ConfiguracaoImportacaoPdf, ValoresConfiguracaoImportacaoPdf,
  PluggyStatus, ConfiguracaoPluggyAdmin, FechamentoPrevia,
  PreferenciaNotificacao, ConfiguracaoNotificacoes, ValoresConfiguracaoNotificacoes,
  Plano, Assinatura, RecursosPlanoAdmin, PlanoRecursoValor, PagamentoAssinatura, ConfiguracaoAuth,
  PainelAssinaturas, Assinante, PagamentoAdmin, PreviaTroca, HistoricoTroca, RelatorioCobrancasCanceladas, OrigemCancelamento, CredencialGateway, PlanoAdmin,
  ConfiguracaoEmail, SolicitacaoContato, PerguntaFrequente, ConfiguracaoGeral,
  ConfiguracaoArmazenamento, ResultadoTesteArmazenamento, StatusMigracaoArmazenamento,
  EscopoParcelas, TransactionType, TransactionStatus, TipoRecorrencia, TipoAlerta, CanalAlerta, PluggyAmbiente, GoalStatus,
  AccountType, ModalidadeCartao, OrigemNota, CicloCobranca, StatusAssinatura, StatusPagamento, GatewayPagamento, AmbienteGateway,
  ProvedorEmail,
  Financiamento, FinanciamentoResumo, SimulacaoFinanciamento, ParcelaFinanciamento, AmortizacaoExtraResultado, AmortizacaoExtraLancada,
  SistemaAmortizacao, StatusFinanciamento, IndiceCorrecaoMonetaria, EstrategiaAmortizacaoExtra,
  Cor, ModeloVeiculo, Veiculo, VeiculoResumo, SalvarVeiculoRequest, VenderVeiculoRequest, RegistrarOdometroRequest, RegistrarOdometroResultado,
  CriarModeloManualRequest, CriarModeloFipeRequest, ModeloFipeResultado, ValorFipeVeiculo, FipeLista, ConfiguracaoFipe, SalvarConfiguracaoFipe,
  Abastecimento, SalvarAbastecimentoRequest, SalvarAbastecimentoResultado, ConsumoVeiculo, DespesaVeiculo, SalvarDespesaVeiculoRequest,
  AbastecimentoSugerido, RegistrarAbastecimentoNotaRequest,
  ItemManutencao, SalvarItemManutencaoRequest, CarregarCatalogoRequest, CatalogoManutencao, RegistroManutencao,
  SalvarRegistroManutencaoRequest, SalvarRegistroManutencaoResultado, Vencimento, InsightsVeiculo, MonitorFipe,
  AtualizarOnboardingRequest, OnboardingInfo, TutoriaisPlanos,
  TipoVeiculo,
} from '../types'

// ── Auth ────────────────────────────────────────────────────────────────────
export const authApi = {
  login: (data: LoginRequest) => api.post<LoginResponse>('/api/auth/login', data).then(r => r.data),
  refresh: (refreshToken: string) => api.post<RefreshResponse>('/api/auth/refresh', { refreshToken }).then(r => r.data),
  /** Encerra só a sessão deste navegador. Não exige token de acesso: o refresh token identifica a sessão. */
  sair: (refreshToken: string) => api.post('/api/auth/sair', { refreshToken }).then(r => r.data),
  /** Encerra as sessões de todos os aparelhos. */
  sairDeTodos: () => api.post('/api/auth/sair-todos').then(r => r.data),
  registrar: (data: { nome: string; email: string; password: string }) =>
    api.post<LoginResponse>('/api/auth/registrar', data).then(r => r.data),
  google: (idToken: string) => api.post<LoginResponse>('/api/auth/google', { idToken }).then(r => r.data),
  configuracao: () => api.get<ConfiguracaoAuth>('/api/auth/configuracao').then(r => r.data),
}

// ── Planos e assinatura ──────────────────────────────────────────────────────
export const planosApi = {
  list: () => api.get<Plano[]>('/api/planos').then(r => r.data),
}

export const assinaturaApi = {
  minha: () => api.get<Assinatura>('/api/assinatura').then(r => r.data),
  pagamentos: () => api.get<PagamentoAssinatura[]>('/api/assinatura/pagamentos').then(r => r.data),
  assinar: (codigoPlano: string, ciclo: CicloCobranca) =>
    api.post<Assinatura>('/api/assinatura', { codigoPlano, ciclo }).then(r => r.data),
  previaTroca: (codigoPlano: string, ciclo: CicloCobranca) =>
    api.post<PreviaTroca>('/api/assinatura/previa-troca', { codigoPlano, ciclo }).then(r => r.data),
  cancelarTroca: () => api.post<Assinatura>('/api/assinatura/troca/cancelar').then(r => r.data),
  historico: () => api.get<HistoricoTroca[]>('/api/assinatura/historico').then(r => r.data),
  cancelar: (motivo: string) => api.post('/api/assinatura/cancelar', { motivo }),
  gerarLink: (pagamentoId: string) =>
    api.post<{ linkPagamento?: string; gateway?: GatewayPagamento; aviso?: string }>(`/api/assinatura/pagamentos/${pagamentoId}/link`)
      .then(r => r.data),
}

// ── Administração ────────────────────────────────────────────────────────────
export const adminApi = {
  painel: (meses = 6) => api.get<PainelAssinaturas>('/api/admin/painel', { params: { meses } }).then(r => r.data),
  assinantes: (params?: { status?: StatusAssinatura; busca?: string }) =>
    api.get<Assinante[]>('/api/admin/assinantes', { params }).then(r => r.data),
  pagamentos: (status?: StatusPagamento) =>
    api.get<PagamentoAdmin[]>('/api/admin/pagamentos', { params: { status } }).then(r => r.data),
  baixarPagamento: (id: string, data: { metodoPagamento?: string; observacao?: string }) =>
    api.post(`/api/admin/pagamentos/${id}/baixar`, data),
  cancelarCobranca: (id: string, motivo: string) =>
    api.post(`/api/admin/pagamentos/${id}/cancelar`, { motivo }),
  cobrancasCanceladas: (params: { de?: string; ate?: string; origem?: OrigemCancelamento }) =>
    api.get<RelatorioCobrancasCanceladas>('/api/admin/pagamentos/cancelados', { params }).then(r => r.data),
  alterarPlano: (userId: string, data: { codigoPlano: string; ciclo: CicloCobranca; comoCortesia: boolean }) =>
    api.post(`/api/admin/usuarios/${userId}/plano`, data),
  cancelarAssinatura: (userId: string, motivo: string) =>
    api.post(`/api/admin/usuarios/${userId}/cancelar`, { motivo }),
  planos: () => api.get<PlanoAdmin[]>('/api/admin/planos').then(r => r.data),
  atualizarPlano: (id: string, data: {
    nome: string; descricao?: string; precoMensal: number; precoAnual: number; ativo: boolean
    maxContas?: number; maxCartoes?: number; maxMetas?: number; maxOrcamentos?: number; maxCompartilhamentos?: number
    maxAtualizacoesPluggyPorDia?: number
    permiteOpenFinance: boolean; permiteRelatoriosAvancados: boolean; permiteExportacao: boolean
    permiteNotasFiscais: boolean; permiteRecorrencias: boolean; permiteCompartilhamento: boolean
  }) => api.put<PlanoAdmin>(`/api/admin/planos/${id}`, data).then(r => r.data),

  fipeConfiguracao: () => api.get<ConfiguracaoFipe>('/api/admin/fipe/configuracao').then(r => r.data),
  salvarFipeConfiguracao: (data: SalvarConfiguracaoFipe) =>
    api.put<ConfiguracaoFipe>('/api/admin/fipe/configuracao', data).then(r => r.data),
  /** Painel da FIPE: consultas de hoje, acertos do cache, erros, idade do dado, série de 14 dias e estado. */
  fipeMonitor: () => api.get<MonitorFipe>('/api/admin/fipe/monitor').then(r => r.data),
  importacaoPdfConfiguracao: () => api.get<ConfiguracaoImportacaoPdf>('/api/admin/configuracoes/importacao-pdf').then(r => r.data),
  salvarImportacaoPdfConfiguracao: (data: ValoresConfiguracaoImportacaoPdf) =>
    api.put<ConfiguracaoImportacaoPdf>('/api/admin/configuracoes/importacao-pdf', data).then(r => r.data),
  notificacoesConfiguracao: () => api.get<ConfiguracaoNotificacoes>('/api/admin/configuracoes/notificacoes').then(r => r.data),
  salvarNotificacoesConfiguracao: (data: ValoresConfiguracaoNotificacoes) =>
    api.put<ConfiguracaoNotificacoes>('/api/admin/configuracoes/notificacoes', data).then(r => r.data),
  pluggyConfiguracao: () => api.get<ConfiguracaoPluggyAdmin>('/api/admin/configuracoes/pluggy').then(r => r.data),
  salvarPluggyConfiguracao: (data: { ativa: boolean; mensagem?: string | null }) =>
    api.put<ConfiguracaoPluggyAdmin>('/api/admin/configuracoes/pluggy', data).then(r => r.data),
  recursosPlano: () => api.get<RecursosPlanoAdmin>('/api/admin/recursos-plano').then(r => r.data),
  salvarRecursosPlano: (valores: PlanoRecursoValor[]) =>
    api.put<RecursosPlanoAdmin>('/api/admin/recursos-plano', { valores }).then(r => r.data),

  gateways: () => api.get<CredencialGateway[]>('/api/admin/gateways').then(r => r.data),
  salvarGateway: (data: {
    gateway: GatewayPagamento; ambiente: AmbienteGateway
    chavePublica?: string; chaveSecreta?: string; segredoWebhook?: string
    ativo: boolean; ehPadrao: boolean
  }) => api.post<CredencialGateway>('/api/admin/gateways', data).then(r => r.data),
  definirGatewayPadrao: (id: string) => api.post(`/api/admin/gateways/${id}/padrao`),
  removerGateway: (id: string) => api.delete(`/api/admin/gateways/${id}`),

  emails: () => api.get<ConfiguracaoEmail[]>('/api/admin/email').then(r => r.data),
  salvarEmail: (data: {
    provedor: ProvedorEmail; remetenteEmail: string; remetenteNome: string
    smtpHost?: string; smtpPorta?: number; smtpUsuario?: string; smtpSenha?: string; smtpUsarSsl: boolean
    resendApiKey?: string; sendGridApiKey?: string; ativo: boolean; ehPadrao: boolean
  }) => api.post<ConfiguracaoEmail>('/api/admin/email', data).then(r => r.data),
  definirEmailPadrao: (id: string) => api.post(`/api/admin/email/${id}/padrao`),
  testarEmail: (id: string, destinatario: string) => api.post(`/api/admin/email/${id}/testar`, { destinatario }),
  removerEmail: (id: string) => api.delete(`/api/admin/email/${id}`),

  contatos: (respondida?: boolean) => api.get<SolicitacaoContato[]>('/api/admin/contatos', { params: { respondida } }).then(r => r.data),
  responderContato: (id: string, respostaTexto: string) => api.post(`/api/admin/contatos/${id}/responder`, { respostaTexto }),

  faq: () => api.get<PerguntaFrequente[]>('/api/admin/faq').then(r => r.data),
  criarFaq: (data: { pergunta: string; resposta: string; ordem: number; ativa: boolean }) =>
    api.post<PerguntaFrequente>('/api/admin/faq', data).then(r => r.data),
  atualizarFaq: (id: string, data: { pergunta: string; resposta: string; ordem: number; ativa: boolean }) =>
    api.put<PerguntaFrequente>(`/api/admin/faq/${id}`, data).then(r => r.data),
  removerFaq: (id: string) => api.delete(`/api/admin/faq/${id}`),

  configuracaoGeral: () => api.get<ConfiguracaoGeral>('/api/admin/configuracao-geral').then(r => r.data),
  salvarConfiguracaoGeral: (data: ConfiguracaoGeral) => api.put<ConfiguracaoGeral>('/api/admin/configuracao-geral', data).then(r => r.data),

  armazenamento: () => api.get<ConfiguracaoArmazenamento>('/api/admin/armazenamento').then(r => r.data),
  salvarArmazenamento: (data: { accountId?: string; endpoint?: string; bucket?: string; accessKeyId?: string; secretAccessKey?: string }) =>
    api.put<ConfiguracaoArmazenamento>('/api/admin/armazenamento', data).then(r => r.data),
  testarArmazenamento: () => api.post<ResultadoTesteArmazenamento>('/api/admin/armazenamento/testar').then(r => r.data),
  removerArmazenamento: () => api.delete('/api/admin/armazenamento'),
  migrarArmazenamento: () => api.post<StatusMigracaoArmazenamento>('/api/admin/armazenamento/migrar').then(r => r.data),
  statusMigracaoArmazenamento: () => api.get<StatusMigracaoArmazenamento>('/api/admin/armazenamento/migrar/status').then(r => r.data),
}

// ── Institucional (site público, sem login) ───────────────────────────────────
export const institucionalApi = {
  faq: () => api.get<PerguntaFrequente[]>('/api/faq').then(r => r.data),
  configuracaoGeral: () => api.get<ConfiguracaoGeral>('/api/configuracao-geral').then(r => r.data),
  enviarContato: (data: { nome: string; email: string; telefone?: string; mensagem: string }) =>
    api.post('/api/contato', data),
}

// ── Redefinição de senha ────────────────────────────────────────────────────
export const authRecuperacaoApi = {
  esqueciSenha: (email: string) => api.post<{ message?: string }>('/api/auth/esqueci-senha', { email }).then(r => r.data),
  redefinirSenha: (token: string, novaSenha: string) =>
    api.post<{ message?: string }>('/api/auth/redefinir-senha', { token, novaSenha }).then(r => r.data),
}

// ── Download do app (site institucional, sem login) ───────────────────────────
export const appDownloadApi = {
  gerarLinkApk: () => api.post<{ url: string; expiraEm: string }>('/api/app/apk/link-publico').then(r => r.data),
}

// ── Dashboard ───────────────────────────────────────────────────────────────
export const dashboardApi = {
  get: (mes?: number, ano?: number) => api.get<DashboardSummary>('/api/dashboard', { params: { mes, ano } }).then(r => r.data),
}

// ── Contas ──────────────────────────────────────────────────────────────────
export const contasApi = {
  list: () =>
    api.post<PagedResult<FinancialAccount>>('/api/contas/listar', { itensPorPagina: 100 }).then(r => r.data.itens),
  criar: (data: { name: string; institution: string; type: AccountType; balance: number; logo?: string }) =>
    api.post<FinancialAccount>('/api/contas', data).then(r => r.data),
  atualizar: (id: string, data: Partial<{ name: string; institution: string; type: AccountType }>) =>
    api.put<FinancialAccount>(`/api/contas/${id}`, data).then(r => r.data),
  remove: (id: string) => api.delete(`/api/contas/${id}`),
    previaSaldoAbertura: (id: string, params: { dataCorte: string; saldo: number }) =>
      api.get<PreviaSaldoAbertura>(`/api/contas/${id}/saldo-abertura/previa`, { params }).then(r => r.data),
    definirSaldoAbertura: (id: string, data: SaldoAberturaRequest) =>
      api.post<ResultadoSaldoAbertura>(`/api/contas/${id}/saldo-abertura`, data).then(r => r.data),
}

// ── Notas fiscais ────────────────────────────────────────────────────────────
export const notasFiscaisApi = {
  list: (params?: { mes?: number; ano?: number; dataInicio?: string; dataFim?: string; pagina?: number; itensPorPagina?: number }) =>
    api.post<PagedResult<NotaFiscal>>('/api/notas-fiscais/listar', { itensPorPagina: 50, ...params }).then(r => r.data),
  obter: (id: string) => api.get<NotaFiscal>(`/api/notas-fiscais/${id}`).then(r => r.data),
  criar: (data: {
    chave?: string; urlConsulta?: string; cnpjEmitente?: string; nomeEmitente?: string
    dataEmissao: string; valorTotal: number; origem: OrigemNota; observacao?: string
    itens?: NotaItemEntrada[]
    accountId?: string; categoriaId?: string; descricao?: string
    cartaoId?: string; debito?: boolean; numParcelas?: number
  }) => api.post<NotaFiscal>('/api/notas-fiscais', data).then(r => r.data),
  remover: (id: string) => api.delete(`/api/notas-fiscais/${id}`),
  resumoItens: (data: { dataInicio?: string; dataFim?: string; agruparPor?: 'dia' | 'semana' | 'mes' | 'ano' }) =>
    api.post<ResumoItens>('/api/notas-fiscais/itens/resumo', data).then(r => r.data),
  catalogoItens: () => api.get<CatalogoItens>('/api/notas-fiscais/itens/catalogo').then(r => r.data),
  /** escopo: 'todas' (padrão), 'daqui_pra_frente' ou 'somente_esta'. */
  corrigirCategoriaItem: (itemId: string, categoria: string, escopo: 'todas' | 'daqui_pra_frente' | 'somente_esta') =>
    api.put(`/api/notas-fiscais/itens/${itemId}/categoria`, { categoria, escopo }),
  definirCoberturaItem: (itemId: string, meses: number) => api.put(`/api/notas-fiscais/itens/${itemId}/cobertura`, { meses }),
  /** quantidade nula apaga a contagem. */
  definirEstoqueItem: (itemId: string, quantidade: number | null) => api.put(`/api/notas-fiscais/itens/${itemId}/estoque`, { quantidade }),
  /** Histórico de preço por item nas notas importadas (busca por texto, mínimo 2 letras). */
  itensComprados: (data: { busca?: string; dataInicio?: string; dataFim?: string; categoria?: string; recorrencia?: 'mensal' | 'anual' | 'avulso' }) =>
    api.post<ItemCompradoGrupo[]>('/api/notas-fiscais/itens-comprados', data).then(r => r.data),
  gestaoItens: () => api.get<GestaoItens>('/api/notas-fiscais/itens/gestao').then(r => r.data),
  salvarConfiguracaoItens: (data: ConfiguracaoItens) => api.put<ConfiguracaoItens>('/api/notas-fiscais/itens/configuracao', data).then(r => r.data),
  ligarGrupoOrcamento: (grupo: string, categoriaId: string | null) => api.put(`/api/notas-fiscais/itens/grupos/${grupo}/orcamento`, { categoriaId }),
  apagarRegraCategoria: (regraId: string) => api.delete(`/api/notas-fiscais/itens/regras/${regraId}`),
  marcarRecorrenciaItem: (itemId: string, tipo: TipoMarcaRecorrencia) => api.put(`/api/notas-fiscais/itens/${itemId}/recorrencia`, { tipo }),
  sugestoesCompra: () => api.get<SugestoesCompra>('/api/notas-fiscais/itens/sugestoes').then(r => r.data),
  importarHtml: (data: { chave: string; urlConsulta?: string; html?: string; accountId?: string; categoriaId?: string; descricao?: string }) =>
    api.post<NotaFiscal>('/api/notas-fiscais/importar-html', data).then(r => r.data),
  reprocessar: (id: string) => api.post<NotaFiscal>(`/api/notas-fiscais/${id}/reprocessar`).then(r => r.data),
  definirApelido: (cnpj: string, apelido: string | null) => api.put(`/api/notas-fiscais/estabelecimentos/${cnpj}/apelido`, { apelido }),
  lancamentosCandidatos: (id: string) => api.get<LancamentoCandidato[]>(`/api/notas-fiscais/${id}/lancamentos-candidatos`).then(r => r.data),
  vincular: (id: string, transacaoId: string) => api.post<NotaFiscal>(`/api/notas-fiscais/${id}/vincular`, { transacaoId }).then(r => r.data),
  criarLancamento: (id: string, data: { accountId?: string; cartaoId?: string; debito?: boolean; numParcelas?: number; categoriaId?: string; descricao?: string; partes?: ParteCompraRequest[] }) =>
    api.post<NotaFiscal>(`/api/notas-fiscais/${id}/criar-lancamento`, data).then(r => r.data),
  desvincular: (id: string) => api.delete<NotaFiscal>(`/api/notas-fiscais/${id}/vinculo`).then(r => r.data),
  /** A nota parece um abastecimento? Litros, valor, combustível, posto e o lançamento já vinculado (plano veiculos.nota_fiscal). */
  abastecimentoSugerido: (id: string) =>
    api.get<AbastecimentoSugerido>(`/api/notas-fiscais/${id}/abastecimento-sugerido`).then(r => r.data),
  /** Cria o abastecimento da nota e adota o lançamento dela. Com alerta de km responde `gravado = false`. */
  registrarAbastecimento: (id: string, data: RegistrarAbastecimentoNotaRequest) =>
    api.post<SalvarAbastecimentoResultado>(`/api/notas-fiscais/${id}/registrar-abastecimento`, data).then(r => r.data),
  /** Essencial x opcional, categorias, itens que mais pesaram e comparação de preço (Premium em diante). */
  insights: (id: string) => api.get<InsightsNota>(`/api/notas-fiscais/${id}/insights`).then(r => r.data),
  /** Troca a classificação só deste item da nota (0 = volta ao padrão do grupo). */
  definirEssencialItem: (itemId: string, essencial: EssencialOpcional) =>
    api.put(`/api/notas-fiscais/itens/${itemId}/essencial`, { essencial }),
}

// ── Transações ──────────────────────────────────────────────────────────────
// ── Grupos de itens e marcas ─────────────────────────────────────────────────
export const gruposItensApi = {
  list: () => api.get<GrupoItem[]>('/api/itens/grupos').then(r => r.data),
  criar: (data: SalvarGrupoItemRequest) => api.post<GrupoItem>('/api/itens/grupos', data).then(r => r.data),
  atualizar: (id: string, data: SalvarGrupoItemRequest) => api.put<GrupoItem>(`/api/itens/grupos/${id}`, data).then(r => r.data),
  remover: (id: string) => api.delete(`/api/itens/grupos/${id}`),
  detalhe: (id: string) => api.get<GrupoDetalhe>(`/api/itens/grupos/${id}/detalhe`).then(r => r.data),
  /** Fila de itens que nenhuma regra casou com segurança, agrupados por descrição normalizada. */
  semGrupo: () => api.get<ItemSemGrupo[]>('/api/itens/sem-grupo').then(r => r.data),
  vincularGrupo: (descricaoNormalizada: string, grupoId: string) =>
    api.put('/api/itens/vinculo-grupo', { descricaoNormalizada, grupoId }),
  vincularMarca: (descricaoNormalizada: string, marca: string) =>
    api.put('/api/itens/vinculo-marca', { descricaoNormalizada, marca }),
  marcas: () => api.get<string[]>('/api/itens/marcas').then(r => r.data),
  /** Só roda quando o usuário aciona; passa por todas as notas dele. */
  reprocessarHistorico: () =>
    api.post<ReprocessarHistoricoResultado>('/api/itens/grupos/reprocessar-historico').then(r => r.data),
  /** Catálogo fixo de grupos prontos; jaExiste marca os que o usuário já tem. */
  sugeridos: () => api.get<GrupoSugerido[]>('/api/itens/grupos/sugeridos').then(r => r.data),
  /** Cria os escolhidos (sem chaves = todos que faltam). Não reprocessa o histórico. */
  criarSugeridos: (chaves?: string[]) =>
    api.post<CriarGruposSugeridosResultado>('/api/itens/grupos/sugeridos', { chaves } satisfies CriarGruposSugeridosRequest).then(r => r.data),
  definirEssencial: (id: string, essencial: EssencialOpcional) =>
    api.put(`/api/itens/grupos/${id}/essencial`, { essencial }),
}

// ── Compra dividida em cartões ───────────────────────────────────────────────
export const comprasDivididasApi = {
  cartoesUtilizaveis: () => api.get<CartaoUtilizavel[]>('/api/compras-divididas/cartoes-utilizaveis').then(r => r.data),
  criar: (data: CriarCompraDivididaRequest) => api.post<CompraDividida>('/api/compras-divididas', data).then(r => r.data),
  obter: (divisaoId: string) => api.get<CompraDividida>(`/api/compras-divididas/${divisaoId}`).then(r => r.data),
  /** Recria a compra inteira dentro de uma transação. */
  atualizar: (divisaoId: string, data: CriarCompraDivididaRequest) =>
    api.put<CompraDividida>(`/api/compras-divididas/${divisaoId}`, data).then(r => r.data),
  remover: (divisaoId: string) => api.delete(`/api/compras-divididas/${divisaoId}`),
}

// ── Listas de compras ────────────────────────────────────────────────────────
export const listasComprasApi = {
  list: () => api.get<ListaComprasResumo[]>('/api/listas-compras').then(r => r.data),
  criar: (nome: string) => api.post<ListaCompras>('/api/listas-compras', { nome }).then(r => r.data),
  renomear: (id: string, nome: string) => api.put(`/api/listas-compras/${id}`, { nome }),
  remover: (id: string) => api.delete(`/api/listas-compras/${id}`),
  obter: (id: string) => api.get<ListaCompras>(`/api/listas-compras/${id}`).then(r => r.data),
  adicionarItem: (id: string, data: AdicionarItemListaRequest) =>
    api.post<ListaCompras>(`/api/listas-compras/${id}/itens`, data).then(r => r.data),
  atualizarItem: (id: string, itemId: string, data: AdicionarItemListaRequest) =>
    api.put<ListaCompras>(`/api/listas-compras/${id}/itens/${itemId}`, data).then(r => r.data),
  removerItem: (id: string, itemId: string) => api.delete(`/api/listas-compras/${id}/itens/${itemId}`),
  /** Sem quantidadeComprada, marcar = tudo. Com ela (total comprado, não é incremento): parcial se menor que a quantidade do item. */
  marcarItem: (id: string, itemId: string, marcado: boolean, quantidadeComprada?: number) =>
    api.put(`/api/listas-compras/${id}/itens/${itemId}/marcado`, { marcado, quantidadeComprada }),
  /** Propõe baixas (itens da nota x pendentes da lista) e faltas; nada é gravado. */
  conciliarNota: (id: string, notaId: string) =>
    api.post<ConciliacaoLista>(`/api/listas-compras/${id}/conciliar-nota/${notaId}`).then(r => r.data),
  aplicarConciliacao: (id: string, data: AplicarConciliacaoRequest) =>
    api.post<{ listaNovaId?: string }>(`/api/listas-compras/${id}/aplicar-conciliacao`, data).then(r => r.data),
}

export const transacoesApi = {
  /** Informe o saldo atual do banco (o rendimento é a diferença) ou o valor do rendimento, só um dos dois. */
  registrarRendimento: (data: { accountId: string; saldoAtual?: number; valor?: number; date?: string; notes?: string }) =>
    api.post<FinancialTransaction>('/api/transacoes/rendimento', data).then(r => r.data),
  /** Corrige o saldo de qualquer conta (pra cima ou pra baixo) via lançamento — nunca escreve direto no saldo. */
  ajustarSaldo: (data: { accountId: string; saldoAtual?: number; valor?: number; date?: string; notes?: string }) =>
    api.post<FinancialTransaction>('/api/transacoes/ajustar-saldo', data).then(r => r.data),
  list: (params?: {
    type?: TransactionType; status?: TransactionStatus; accountId?: string; categoriaId?: string; cartaoId?: string;
    /** true = só lançamentos sem categoria (ignora categoriaId quando marcado). */
    semCategoria?: boolean
    dataInicio?: string; dataFim?: string; pagina?: number; itensPorPagina?: number
    busca?: string; ordenarPor?: 'data' | 'nome' | 'parcela' | 'valor'; ordemDesc?: boolean
    /** true = só movimento de caixa (sem compras no cartão; a fatura as representa). */
    excluirCartao?: boolean
    /** true = pendentes com data anterior a hoje. */
    atrasadas?: boolean
    compraId?: string
    /** Compras feitas num cartão de débito ou pré-pago. */
    cartaoPagamentoId?: string
    /** Só lançamentos desta fatura; com apenasCompras tira os ajustes (estornos e pagamentos). */
    faturaId?: string
    apenasCompras?: boolean
  }) => api.post<PagedResult<FinancialTransaction>>('/api/transacoes/listar', params ?? {}).then(r => r.data),
  get: (id: string) => api.get<FinancialTransaction>(`/api/transacoes/${id}`).then(r => r.data),
  historico: (transactionId?: string) =>
    api.get<FinancialTransactionHistory[]>('/api/transacoes/historico', { params: { transacaoId: transactionId } }).then(r => r.data),
  criar: (data: {
    accountId: string; destinationAccountId?: string; description: string; amount: number; type: TransactionType; status: TransactionStatus;
    categoriaId?: string; cartaoId?: string; date: string; notes?: string; anexoUrl?: string;
    parcelaNumero?: number; parcelaTotalNumero?: number; tagIds?: string[]
    /** Marca este lançamento avulso como ajuste pontual do líquido esperado de uma recorrência de receita naquele mês. */
    ajusteDeRecorrenciaId?: string
  }) => api.post<FinancialTransaction>('/api/transacoes', data).then(r => r.data),
  atualizar: (id: string, data: Partial<{
    description: string; amount: number; type: TransactionType; status: TransactionStatus;
    categoriaId: string; destinationAccountId: string;
    /** Só usado em transferência: dá pra trocar a conta de origem por qualquer uma das duas pernas. */
    accountId: string
    date: string; notes: string; anexoUrl: string; tagIds: string[]
    ajusteDeRecorrenciaId: string; removerAjusteDeRecorrencia: boolean
      /** Data real da baixa ao confirmar (padrão: hoje); nunca futura. */
      dataBaixa: string
  }>, escopo: EscopoParcelas = 1) => api.put<FinancialTransaction>(`/api/transacoes/${id}`, data, { params: { escopo } }).then(r => r.data),
  remover: (id: string, escopo: EscopoParcelas = 1) => api.delete(`/api/transacoes/${id}`, { params: { escopo } }),
  listarCandidatosFusao: (id: string) => api.get<CandidatoFusaoInfo[]>(`/api/transacoes/${id}/candidatos-fusao`).then(r => r.data),
  fundir: (id: string, idManual: string) => api.post(`/api/transacoes/${id}/fundir/${idManual}`),
}

// ── Metas ───────────────────────────────────────────────────────────────────
export const metasApi = {
  list: () => api.get<FinancialGoal[]>('/api/metas').then(r => r.data),
  criar: (data: { name: string; icon?: string; targetAmount: number; currentAmount: number; targetDate?: string }) =>
    api.post<FinancialGoal>('/api/metas', data).then(r => r.data),
  atualizar: (id: string, data: Partial<{
    name: string; icon: string; targetAmount: number; currentAmount: number; targetDate: string; status: GoalStatus
  }>) => api.put<FinancialGoal>(`/api/metas/${id}`, data).then(r => r.data),
  remover: (id: string) => api.delete(`/api/metas/${id}`),
  historico: (id: string) => api.get<MetaSnapshot[]>(`/api/metas/${id}/historico`).then(r => r.data),
}

// ── Compartilhamento ─────────────────────────────────────────────────────────
export const compartilhamentosApi = {
  enviados: () => api.get<Compartilhamento[]>('/api/compartilhamentos/enviados').then(r => r.data),
  recebidos: () => api.get<Compartilhamento[]>('/api/compartilhamentos/recebidos').then(r => r.data),
  contextos: () => api.get<ContextoCompartilhado[]>('/api/compartilhamentos/contextos').then(r => r.data),
  convidar: (data: { email: string; permissoes: Permissoes; consentimentoSaude?: boolean }) =>
    api.post<Compartilhamento>('/api/compartilhamentos', data).then(r => r.data),
  /** Só o convidado liga: libera os cartões dele para o dono usar em compras divididas. */
  definirCartoesDoConvidado: (id: string, liberado: boolean) =>
    api.put(`/api/compartilhamentos/${id}/cartoes-do-convidado`, { liberado }),
  atualizarPermissoes: (id: string, permissoes: Permissoes, consentimentoSaude?: boolean) =>
    api.put<Compartilhamento>(`/api/compartilhamentos/${id}/permissoes`, { permissoes, consentimentoSaude }).then(r => r.data),
  aceitar: (id: string) => api.post(`/api/compartilhamentos/${id}/aceitar`),
  recusar: (id: string) => api.post(`/api/compartilhamentos/${id}/recusar`),
  revogar: (id: string) => api.delete(`/api/compartilhamentos/${id}`),
  relacionadas: () => api.get<PessoaRelacionada[]>('/api/compartilhamentos/relacionadas').then(r => r.data),
}

// ── Notificações ─────────────────────────────────────────────────────────────
export const notificacoesApi = {
  list: () => api.get<Notificacao[]>('/api/notificacoes').then(r => r.data),
  marcarLida: (id: string) => api.post(`/api/notificacoes/${id}/marcar-lida`),
  marcarTodasLidas: () => api.post('/api/notificacoes/marcar-todas-lidas'),
  preferencias: () => api.get<PreferenciaNotificacao[]>('/api/notificacoes/preferencias').then(r => r.data),
  salvarPreferencia: (data: { tipo: string; ativa: boolean }) =>
    api.put<PreferenciaNotificacao>('/api/notificacoes/preferencias', data).then(r => r.data),
}

// ── Open Finance ─────────────────────────────────────────────────────────────
export const openFinanceApi = {
  list: () => api.get<OpenFinanceConnection[]>('/api/open-finance/conexoes').then(r => r.data),
  remover: (id: string) => api.delete(`/api/open-finance/conexoes/${id}`),
}

// ── Pluggy ───────────────────────────────────────────────────────────────────
export const pluggyStatusApi = {
  /** Interruptor geral: ativa=false esconde a conexão com o banco (o servidor responde 503 nas rotas que chamam a Pluggy). */
  get: () => api.get<PluggyStatus>('/api/pluggy/status').then(r => r.data),
}

export const pluggyContasApi = {
  /** `data` vem nulo em API antiga; `duplicidade` só quando o item recém-registrado repete um banco já conectado. */
  registrarItem: (itemId: string) => api.post<RegistrarItemResultado | null>('/api/pluggy/itens', { itemId }).then(r => r.data),
  /** Com `itemId`, o token serve para abrir o widget em modo de atualização daquela conexão. */
  connectToken: (itemId?: string) =>
    api.post<{ accessToken: string; incluirSandbox: boolean }>('/api/pluggy/connect-token', itemId ? { itemId } : undefined).then(r => r.data),
  excluirDuplicadaPrevia: (itemId: string, mantidoItemId: string) =>
    api.get<PreviaExcluirDuplicadaInfo>(`/api/pluggy/itens/${itemId}/excluir-duplicada/previa`, { params: { mantidoItemId } }).then(r => r.data),
  excluirDuplicada: (itemId: string, data: { mantidoItemId: string; mapeamento?: { contaPluggyAntigaId: string; contaPluggyNovaId: string }[] }) =>
    api.post<ExcluirDuplicadaResultadoInfo>(`/api/pluggy/itens/${itemId}/excluir-duplicada`, data).then(r => r.data),
  list: () => api.get<ContaPluggyInfo[]>('/api/pluggy/contas').then(r => r.data),
  transacoes: (accountId: string, params: { de?: string; ate?: string; cursor?: string }) =>
    api.get<CursorResultInfo<TransacaoPluggyInfo>>(`/api/pluggy/contas/${accountId}/transacoes`, { params }).then(r => r.data),
}

export const pluggyVinculosApi = {
  list: () => api.get<PluggyVinculoInfo[]>('/api/pluggy/vinculos').then(r => r.data),
  vincular: (data: { pluggyAccountId: string; financialAccountId?: string; cartaoId?: string; trocar?: boolean }) =>
    api.post<PluggyVinculoInfo>('/api/pluggy/vinculos', data).then(r => r.data),
  atualizar: (id: string, aceitarAutomatico: boolean) =>
    api.patch(`/api/pluggy/vinculos/${id}`, { aceitarAutomatico }),
  desvincular: (id: string) => api.delete(`/api/pluggy/vinculos/${id}`),
  configuracaoVinculo: (id: string) =>
    api.get<ConfiguracaoVinculoInfo>(`/api/pluggy/vinculos/${id}/configuracao`).then(r => r.data),
  /** Somente leitura: o que configurar faria com este corte e saldo (lê a Pluggy; não grava). */
  previaConfiguracao: (id: string, params: { dataCorte: string; saldo?: number }, signal?: AbortSignal) =>
    api.get<PreviaConfiguracaoInfo>(`/api/pluggy/vinculos/${id}/configuracao/previa`, { params, signal }).then(r => r.data),
  configurarVinculo: (id: string, data: ConfigurarVinculoRequest) =>
    api.post<ResumoConfiguracaoInfo>(`/api/pluggy/vinculos/${id}/configurar`, data).then(r => r.data),
  configurarPadraoVinculo: (id: string) =>
    api.post<ResumoConfiguracaoInfo>(`/api/pluggy/vinculos/${id}/configurar-padrao`).then(r => r.data),
  resumoRefazer: (id: string, apagarManuais = false) =>
    api.get<ResumoRefazerInfo>(`/api/pluggy/vinculos/${id}/refazer/resumo`, { params: { apagarManuais } }).then(r => r.data),
  refazerVinculo: (id: string, data: RefazerRequest) =>
    api.post<ResultadoRefazerInfo>(`/api/pluggy/vinculos/${id}/refazer`, data).then(r => r.data),
}

export const pluggyPendenciasApi = {
  list: () => api.get<PluggyPendenciaInfo[]>('/api/pluggy/pendencias').then(r => r.data),
  /** descricao/valor: edita antes de aceitar, em vez de aceitar e editar o lançamento depois. */
  aceitar: (id: string, categoriaId?: string, descricao?: string, valor?: number) =>
    api.post(`/api/pluggy/pendencias/${id}/aceitar`, { categoriaId, descricao, valor }),
  vincular: (id: string) => api.post(`/api/pluggy/pendencias/${id}/vincular`),
  manterSeparada: (id: string, categoriaId?: string, descricao?: string, valor?: number) =>
    api.post(`/api/pluggy/pendencias/${id}/manter-separado`, { categoriaId, descricao, valor }),
  confirmarTransferencia: (id: string, contaId: string, categoriaId?: string) =>
    api.post(`/api/pluggy/pendencias/${id}/confirmar-transferencia`, { contaId, categoriaId }),
  confirmarPar: (id: string) => api.post(`/api/pluggy/pendencias/${id}/confirmar-par`),
  vincularTransferencia: (id: string) => api.post(`/api/pluggy/pendencias/${id}/vincular-transferencia`),
  vincularFatura: (id: string, faturaId: string) => api.post(`/api/pluggy/pendencias/${id}/vincular-fatura`, { faturaId }),
  pagarFatura: (id: string, faturaId: string) => api.post(`/api/pluggy/pendencias/${id}/pagar-fatura`, { faturaId }),
  ignorar: (id: string) => api.post(`/api/pluggy/pendencias/${id}/ignorar`),
  /** Tipo 5: liga o débito a uma fatura paga ou a um ajuste que já existe (exatamente um dos dois). */
  vincularPagamentoConta: (id: string, alvo: { faturaId?: string; ajusteId?: string }) =>
    api.post(`/api/pluggy/pendencias/${id}/pagamento-conta/vincular`, alvo),
  pagarPagamentoConta: (id: string, faturaId: string) => api.post(`/api/pluggy/pendencias/${id}/pagamento-conta/pagar`, { faturaId }),
  parcialPagamentoConta: (id: string, faturaId: string) => api.post(`/api/pluggy/pendencias/${id}/pagamento-conta/parcial`, { faturaId }),
  outraCoisaPagamentoConta: (id: string, categoriaId?: string) =>
    api.post(`/api/pluggy/pendencias/${id}/pagamento-conta/outra-coisa`, { categoriaId }),
  comprasParaEstorno: (id: string) => api.get<CompraCandidataEstorno[]>(`/api/pluggy/pendencias/${id}/compras-estorno`).then(r => r.data),
  confirmarEstorno: (id: string, compraId: string) => api.post(`/api/pluggy/pendencias/${id}/confirmar-estorno`, { compraId }),
}

export const pluggyHistoricoApi = {
  list: () => api.get<PluggyHistoricoItemInfo[]>('/api/pluggy/historico').then(r => r.data),
}

export const pluggyCategoriasMapeamentoApi = {
  list: () => api.get<PluggyCategoriaMapeamentoInfo[]>('/api/pluggy/categorias-mapeamento').then(r => r.data),
  criar: (data: { categoriaPluggy: string; categoriaId: string }) =>
    api.post<PluggyCategoriaMapeamentoInfo>('/api/pluggy/categorias-mapeamento', data).then(r => r.data),
  remover: (id: string) => api.delete(`/api/pluggy/categorias-mapeamento/${id}`),
}

export const regrasCategorizacaoApi = {
  list: () => api.get<RegraCategorizacao[]>('/api/pluggy/regras-categorizacao').then(r => r.data),
  criar: (data: SalvarRegraCategorizacao) => api.post<RegraCategorizacao>('/api/pluggy/regras-categorizacao', data).then(r => r.data),
  atualizar: (id: string, data: SalvarRegraCategorizacao) => api.put<RegraCategorizacao>(`/api/pluggy/regras-categorizacao/${id}`, data).then(r => r.data),
  remover: (id: string) => api.delete(`/api/pluggy/regras-categorizacao/${id}`),
  reordenar: (idsNaOrdem: string[]) => api.put('/api/pluggy/regras-categorizacao/ordem', { idsNaOrdem }),
  testar: (data: SalvarRegraCategorizacao) => api.post<number>('/api/pluggy/regras-categorizacao/testar', data).then(r => r.data),
  categoriasConhecidas: () => api.get<string[]>('/api/pluggy/categorias-pluggy-conhecidas').then(r => r.data),
}

export const pluggyCredenciaisApi = {
  get: () => api.get<PluggyCredencialInfo>('/api/pluggy-credenciais').then(r => r.data),
  salvar: (data: { clientId: string; clientSecret: string; ambiente: PluggyAmbiente }) =>
    api.post<PluggyCredencialInfo>('/api/pluggy-credenciais', data).then(r => r.data),
  remover: () => api.delete('/api/pluggy-credenciais'),
}

// ── Usuários ─────────────────────────────────────────────────────────────────
export const usuariosApi = {
  list: () => api.post<PagedResult<UsuarioItem>>('/api/usuarios/listar', { itensPorPagina: 100 }).then(r => r.data.itens),
  /** Lista com filtros, ordenação e paginação feitos no servidor. */
  listar: (filtro: FiltroUsuarios) => api.post<PagedResult<UsuarioItem>>('/api/usuarios/listar', { itensPorPagina: 20, ...filtro }).then(r => r.data),
  criar: (data: { name: string; email: string; password: string; role: string }) =>
    api.post<UsuarioItem>('/api/usuarios', data).then(r => r.data),
  alterarRole: (id: string, role: string) => api.patch(`/api/usuarios/${id}/role`, { role }),
  remover: (id: string) => api.delete(`/api/usuarios/${id}`),
}

// ── Categorias ───────────────────────────────────────────────────────────────
export const categoriasApi = {
  list: (params?: { parentId?: string; incluirInativas?: boolean }) =>
    api.get<Categoria[]>('/api/categorias', { params }).then(r => r.data),
  criar: (data: { nome: string; icone?: string; cor?: string; parentId?: string }) =>
    api.post<Categoria>('/api/categorias', data).then(r => r.data),
  atualizar: (id: string, data: Partial<{ nome: string; icone: string; cor: string; isActive: boolean }>) =>
    api.put<Categoria>(`/api/categorias/${id}`, data).then(r => r.data),
  /** Apaga de verdade se nada usa a categoria; se está em uso, só desativa (o retorno diz qual dos dois). */
  remover: (id: string) => api.delete<RemocaoCategoria>(`/api/categorias/${id}`).then(r => r.data),
  listTags: () => api.get<TagItem[]>('/api/categorias/tags').then(r => r.data),
  criarTag: (data: { nome: string; cor?: string }) => api.post<TagItem>('/api/categorias/tags', data).then(r => r.data),
  removerTag: (id: string) => api.delete(`/api/categorias/tags/${id}`),
}

// ── Recorrências ─────────────────────────────────────────────────────────────
export const recorrenciasApi = {
  list: (params?: { apenasAtivas?: boolean }) =>
    api.post<PagedResult<RecurringTransaction>>('/api/recorrencias/listar', { itensPorPagina: 100, ...params }).then(r => r.data),
  criar: (data: {
    accountId: string; description: string; amount: number; type: TransactionType; status: TransactionStatus;
    categoriaId?: string; tipoRecorrencia: TipoRecorrencia; intervalo: number;
    dataInicio: string; quantidadeParcelas?: number | null; dataFim?: string | null;
    adicionarNumeroParcela: boolean; notes?: string; semLancamentoAtePassado?: boolean
    /** Só quando type = Expense: marca esta recorrência como desconto automático de uma recorrência de receita. */
    descontoDeRecorrenciaId?: string
  }) => api.post<RecurringTransaction>('/api/recorrencias', data).then(r => r.data),
  obter: (id: string) => api.get<RecurringTransaction>(`/api/recorrencias/${id}`).then(r => r.data),
  atualizar: (id: string, data: Partial<{
    description: string; amount: number; type: TransactionType; categoriaId: string
    tipoRecorrencia: TipoRecorrencia; intervalo: number
    quantidadeParcelas: number | null; adicionarNumeroParcela: boolean
    dataFim: string | null; removerDataFim: boolean; ativa: boolean; notes: string
    descontoDeRecorrenciaId: string; removerDescontoDeRecorrencia: boolean
  }>) => api.put<RecurringTransaction>(`/api/recorrencias/${id}`, data).then(r => r.data),
  remover: (id: string) => api.delete(`/api/recorrencias/${id}`),
  gerar: (id: string, meses = 3) => api.post(`/api/recorrencias/${id}/gerar`, null, { params: { meses } }),
  projetar: (id: string) => api.post<number>(`/api/recorrencias/${id}/projetar`).then(r => r.data),
  listarOcorrencias: (id: string) => api.get<OcorrenciaRecorrencia[]>(`/api/recorrencias/${id}/ocorrencias`).then(r => r.data),
  obterLiquido: (id: string, data: string) => api.get<LiquidoOcorrencia>(`/api/recorrencias/${id}/liquido`, { params: { data } }).then(r => r.data),
  toggleLancamentoOcorrencia: (id: string, transacaoId: string, gerarLancamento: boolean) =>
    api.put(`/api/recorrencias/${id}/ocorrencias/${transacaoId}/gerar-lancamento`, { gerarLancamento }),
  toggleLancamentoEmMassa: (id: string, gerarLancamento: boolean) =>
    api.put<number>(`/api/recorrencias/${id}/ocorrencias/gerar-lancamento`, { gerarLancamento }).then(r => r.data),
  adiantarOcorrencias: (id: string, data: { desdeNumero?: number; ateNumero: number; valorPago: number; data: string }) =>
    api.post<number>(`/api/recorrencias/${id}/adiantar`, data).then(r => r.data),
  renegociar: (id: string, data: { novoValorParcela: number; novaQuantidadeParcelas: number; observacao?: string }) =>
    api.post<RecurringTransaction>(`/api/recorrencias/${id}/renegociar`, data).then(r => r.data),
  listarRenegociacoes: (id: string) => api.get<RenegociacaoRecorrencia[]>(`/api/recorrencias/${id}/renegociacoes`).then(r => r.data),
}

// ── Cartões ──────────────────────────────────────────────────────────────────
export const cartoesApi = {
  list: () => api.get<CreditCard[]>('/api/cartoes').then(r => r.data),
  /** Crédito: conta, limite e os dois dias. Débito: só nome e conta. Pré-pago: só nome (e saldo inicial); o app cria a conta Benefício. */
  criar: (data: {
    nome: string; modalidade?: ModalidadeCartao; accountId?: string; limite?: number
    diaFechamento?: number; diaVencimento?: number; saldoInicial?: number
    /** Só no crédito: a compra do dia do fechamento fica na fatura que fecha (padrão: na seguinte). */
    compraNoFechamentoNaFaturaQueFecha?: boolean
    /** Só no crédito: o cartão também serve como débito (padrão: sim). */
    temDebito?: boolean
  }) => api.post<CreditCard>('/api/cartoes', data).then(r => r.data),
  /** Mudar fechamento ou vencimento recalcula as faturas em aberto (as pagas não mudam). */
  atualizar: (id: string, data: Partial<{ nome: string; limite: number; diaFechamento: number; diaVencimento: number; isActive: boolean; temDebito: boolean; compraNoFechamentoNaFaturaQueFecha: boolean }>) =>
    api.put<CreditCard>(`/api/cartoes/${id}`, data).then(r => r.data),
  /** Somente leitura: quais compras do dia do fechamento cairiam em outra fatura com a regra proposta (nada é movido). */
  fechamentoPrevia: (id: string, compraNoFechamento: boolean) =>
    api.get<FechamentoPrevia>(`/api/cartoes/${id}/fechamento-previa`, { params: { compraNoFechamento } }).then(r => r.data),
  remover: (id: string) => api.delete(`/api/cartoes/${id}`),
  listFaturas: (id: string) => api.get<Fatura[]>(`/api/cartoes/${id}/faturas`).then(r => r.data),
  getFatura: (id: string, mes: number, ano: number) =>
    api.get<Fatura>(`/api/cartoes/${id}/faturas/${mes}/${ano}`).then(r => r.data),
  adicionarTransacao: (id: string, data: {
    description: string; amount: number; categoriaId?: string; date: string;
    numParcelas: number; notes?: string
    /** true = compra no débito (sai da conta na hora, à vista). Só em cartão com débito. */
    debito?: boolean
  }) => api.post<CompraCartaoResultado>(`/api/cartoes/${id}/transacoes`, data).then(r => r.data),
  faturasResumo: (params?: { mes?: number; ano?: number; apenasAbertas?: boolean; apenasAtrasadas?: boolean }) =>
    api.get<FaturaResumo[]>('/api/cartoes/faturas', { params }).then(r => r.data),
  /** semDebito: marca como paga sem mexer no saldo da conta. */
  pagarFatura: (faturaId: string, dataPagamento: string, semDebito = false, vincularTransacaoId?: string) =>
    api.post<PagarFaturaResultado | null>(`/api/cartoes/faturas/${faturaId}/pagar`, {
      dataPagamento, ...(semDebito ? { semDebito: true } : {}), ...(vincularTransacaoId ? { vincularTransacaoId } : {}),
    }).then(r => r.data),
  /** Despesa da conta que já veio da Pluggy e parece ser o pagamento desta fatura (nulo quando não há). */
  pagamentoImportado: (faturaId: string, dataPagamento?: string) =>
    api.get<PagamentoJaImportado | null>(`/api/cartoes/faturas/${faturaId}/pagamento-importado`, { params: { dataPagamento } }).then(r => r.data),
  /** Gasto por categoria de uma fatura (+ saldo anterior e ajustes, que fecham com o total). */
  categoriasDaFatura: (faturaId: string) =>
    api.get<FaturaCategorias>(`/api/cartoes/faturas/${faturaId}/categorias`).then(r => r.data),
  /** Marca um lançamento real (ex.: pagamento parcial de fatura importado da Pluggy) como ajuste de uma fatura,
   * sem tocar no lançamento original. Sem faturaId, calcula pela data do lançamento. */
  marcarAjusteFatura: (transacaoId: string, cartaoId: string, faturaId?: string) =>
    api.post(`/api/cartoes/transacoes/${transacaoId}/ajuste-fatura`, { cartaoId, faturaId }),
  /** Move uma compra pra outra fatura do mesmo cartão, mesmo já fechada ou paga. */
  moverParaFatura: (transacaoId: string, faturaId: string) =>
    api.post(`/api/cartoes/transacoes/${transacaoId}/mover-fatura`, { faturaId }),
  /** Edita valor, data e descrição de um ajuste de fatura (fatura não paga; paga = 409). */
  atualizarAjuste: (transacaoId: string, data: { valor: number; data: string; descricao: string }) =>
    api.put(`/api/cartoes/ajustes/${transacaoId}`, data),
  /** Exclui um ajuste de fatura (fatura não paga; paga = 409). */
  removerAjuste: (transacaoId: string) => api.delete(`/api/cartoes/ajustes/${transacaoId}`),
  /** Reabre uma fatura paga pra corrigir lançamentos dela; devolve o total pra conta. */
  reabrirFatura: (faturaId: string) => api.post(`/api/cartoes/faturas/${faturaId}/reabrir`),
  /** Envia o PDF da fatura (multipart, campo "arquivo"); a leitura roda em fila no servidor (202 + jobId). */
  importarPdf: (cartaoId: string, arquivo: File) => {
    const form = new FormData()
    form.append('arquivo', arquivo)
    return api.post<PublicacaoImportacaoPdf>(`/api/cartoes/${cartaoId}/importar-pdf`, form).then(r => r.data)
  },
  /** Polling da leitura do PDF até Pronto/Falhou. 404 = expirou ou não é seu. */
  statusImportacaoPdf: (cartaoId: string, jobId: string) =>
    api.get<StatusImportacaoPdfJob>(`/api/cartoes/${cartaoId}/importar-pdf/${jobId}`).then(r => r.data),
  /** Sugere a fatura de destino pelo ciclo de cada linha (não cria nada). */
  sugerirDestinoImportacaoCsv: (cartaoId: string, linhas: { descricao: string; valor: number; data: string }[]) =>
    api.post<DestinoSugeridoCsv>(`/api/cartoes/${cartaoId}/importar-csv/sugerir-destino`, { linhas }).then(r => r.data),
  /** Confere cada linha do CSV (já parseado no cliente) contra os lançamentos existentes, sem gravar nada. */
  preVisualizarImportacaoCsv: (cartaoId: string, linhas: { descricao: string; valor: number; data: string; parcelaNumero?: number | null; parcelaTotalNumero?: number | null; compraAntiga?: boolean }[], faturaId?: string) =>
    api.post<ItemPreVisualizacaoCsv[]>(`/api/cartoes/${cartaoId}/importar-csv/pre-visualizar`, { linhas, faturaId }).then(r => r.data),
  /** Lançamentos da fatura importada que estão no app mas não no CSV (excluíveis e vinculados à Pluggy). */
  divergenciasImportacaoCsv: (cartaoId: string, linhas: { descricao: string; valor: number; data: string; parcelaNumero?: number | null; parcelaTotalNumero?: number | null; compraAntiga?: boolean }[], faturaId?: string) =>
    api.post<DivergenciasCsv>(`/api/cartoes/${cartaoId}/importar-csv/divergencias`, { linhas, faturaId }).then(r => r.data),

  /** Executa a importação já conferida. excluirIds e mover só valem com faturaId e fatura não paga; excluir nunca atinge lançamento da Pluggy. */
  confirmarImportacaoCsv: (cartaoId: string, linhas: ItemPreVisualizacaoCsv[], faturaId?: string, extras?: { excluirIds?: string[]; excluir?: ExclusaoComEscopo[]; decisoesPar?: DecisaoPar[]; mover?: { transacaoId: string; faturaDestinoId: string }[]; origem?: 'csv' | 'pdf'; faturaVencimento?: string; transferirSaldo?: { faturaAnteriorId: string; valor: number } }) =>
    api.post<ResultadoImportacaoCsv>(`/api/cartoes/${cartaoId}/importar-csv/confirmar`, { linhas, faturaId, ...extras }).then(r => r.data),
  /** Recarga avulsa do pré-pago: receita "Benefícios" na conta do cartão. */
  recarregar: (id: string, data: { valor: number; date?: string; descricao?: string; notes?: string }) =>
    api.post<FinancialTransaction>(`/api/cartoes/${id}/recarga`, data).then(r => r.data),
  listarRecargasAutomaticas: (id: string) => api.get<RecargaAutomatica[]>(`/api/cartoes/${id}/recarga-automatica`).then(r => r.data),
  criarRecargaAutomatica: (id: string, data: { valor: number; dia: number }) =>
    api.post<RecargaAutomatica>(`/api/cartoes/${id}/recarga-automatica`, data).then(r => r.data),
  /** Só o que vier é alterado. `ativa: false` pausa; `ativa: true` retoma. */
  atualizarRecargaAutomatica: (id: string, recargaId: string, data: { valor?: number; dia?: number; ativa?: boolean }) =>
    api.put<RecargaAutomatica>(`/api/cartoes/${id}/recarga-automatica/${recargaId}`, data).then(r => r.data),
  cancelarRecargaAutomatica: (id: string, recargaId: string) => api.delete(`/api/cartoes/${id}/recarga-automatica/${recargaId}`),
}

// ── Orçamento ────────────────────────────────────────────────────────────────
export const orcamentosApi = {
  alterarCategoria: (id: string, categoriaId: string) => api.put(`/api/orcamentos/${id}/categoria`, { categoriaId }),
  lancamentos: (id: string) => api.get<LancamentosDoOrcamento>(`/api/orcamentos/${id}/lancamentos`).then(r => r.data),
  sugestaoLimite: (categoriaId: string) => api.get<SugestaoLimite>('/api/orcamentos/sugestao-limite', { params: { categoriaId } }).then(r => r.data),
  getResumo: (mes: number, ano: number, escopo: 'eu' | 'casal' = 'eu') =>
    api.get<OrcamentoResumo>('/api/orcamentos', { params: { mes, ano, escopo } }).then(r => r.data),
  desfazerPareamento: (id: string) => api.post(`/api/orcamentos/pareamentos/${id}/desfazer`),
  refazerPareamento: (id: string) => api.post(`/api/orcamentos/pareamentos/${id}/refazer`),
  salvar: (data: {
    categoriaId: string; mes: number; ano: number; limiteValor?: number | null; alertaAtivo: boolean
    conjunto?: boolean; participantesUserIds?: string[]
    /** Nulo/omitido = só este mês. 1 = repete todo mês, N = a cada N meses. */
    repetirACadaMeses?: number | null
    /** Só relevante quando já havia repetição antes desta edição: true aplica só neste mês. */
    somenteEsteMes?: boolean
    /** true = o saldo não gasto soma no limite do mês seguinte (provisionamento/reserva). */
    acumularSaldo?: boolean
    /** Modo "valor alvo": junto com dataAlvo, calcula o limite mensal sozinho. Implica acumularSaldo = true. */
    valorAlvo?: number | null
    dataAlvo?: string | null
    /** Planejamento: omitidos mantêm o valor atual do orçamento. */
    tipoMeta?: number
    essencial?: boolean
    ritmoAtivo?: boolean
    ritmoCadencia?: number | null
    ritmoDias?: number | null
    ritmoValor?: number | null
    ritmoAcumula?: boolean
    /** 1 Pelo histórico, 2 Crédito, 3 À vista. */
    projetarComo?: number
  }) => api.post<Orcamento>('/api/orcamentos', data).then(r => r.data),
  /** Projeção de saldo; com compra, também simula. entradas nulo = usa as simulações salvas. */
  projetar: (data: { meses: number; entradas?: EntradaSimulada[] | null; compra?: CompraSimulada | null }) =>
    api.post<Projecao>('/api/orcamentos/projecao', data).then(r => r.data),
  salvarSimulacoes: (entradas: EntradaSimulada[]) => api.put('/api/orcamentos/simulacoes', entradas),
  limparSimulacoes: () => api.delete('/api/orcamentos/simulacoes'),
  contaNaProjecao: (contaId: string, entraNaProjecao: boolean | null) => api.put(`/api/orcamentos/projecao/contas/${contaId}`, { entraNaProjecao }),
  reserva: (tipo: 'valor' | 'fixas' | null, valor?: number | null) => api.put('/api/orcamentos/reserva', { tipo, valor }),
  remover: (id: string) => api.delete(`/api/orcamentos/${id}`),

  listarConvites: () => api.get<ConviteOrcamento[]>('/api/orcamentos/convites').then(r => r.data),
  aceitarConvite: (participanteId: string, categoriaId: string) =>
    api.post(`/api/orcamentos/convites/${participanteId}/aceitar`, { categoriaId }),
  recusarConvite: (participanteId: string) => api.post(`/api/orcamentos/convites/${participanteId}/recusar`),
  sairDoConjunto: (participanteId: string) => api.delete(`/api/orcamentos/participantes/${participanteId}`),
  atualizarNotificacaoParticipante: (participanteId: string, notificacoesAtivas: boolean) =>
    api.put(`/api/orcamentos/participantes/${participanteId}/notificacoes`, { notificacoesAtivas }),
  /** Período livre (De/Até) — sem argumentos, o backend usa os últimos 6 meses como padrão. */
  historico: (dataInicio?: string, dataFim?: string) =>
    api.get<OrcamentoHistorico>('/api/orcamentos/historico', { params: { dataInicio, dataFim } }).then(r => r.data),
}

// ── Alertas ───────────────────────────────────────────────────────────────────
type SalvarAlerta = { tipo: TipoAlerta; canal: CanalAlerta; ativo: boolean; percentualLimite?: number; valorLimite?: number }

export const alertasApi = {
  list: () => api.get<AlertaConfig[]>('/api/alertas').then(r => r.data),
  salvar: (data: SalvarAlerta) => api.post<AlertaConfig>('/api/alertas', data).then(r => r.data),
  atualizar: (id: string, data: SalvarAlerta) => api.put<AlertaConfig>(`/api/alertas/${id}`, data).then(r => r.data),
  remover: (id: string) => api.delete(`/api/alertas/${id}`),
}

// ── Financiamentos ───────────────────────────────────────────────────────────
interface DadosFinanciamento {
  accountId: string; categoriaId?: string; descricao: string; instituicao?: string
  valorTotal: number; valorEntrada?: number; taxaJurosMensal?: number; taxaJurosAnual?: number
  sistemaAmortizacao: SistemaAmortizacao; periodicidade: TipoRecorrencia
  dataPrimeiraParcela: string; quantidadeParcelas?: number | null; dataFinal?: string | null
  indiceCorrecao?: IndiceCorrecaoMonetaria
  /** Veículo financiado (precisa ser do usuário). */
  veiculoId?: string | null
}

export const financiamentosApi = {
  simular: (data: DadosFinanciamento) =>
    api.post<SimulacaoFinanciamento>('/api/financiamentos/simular', data).then(r => r.data),
  list: (params?: { status?: StatusFinanciamento; pagina?: number; itensPorPagina?: number }) =>
    api.post<PagedResult<FinanciamentoResumo>>('/api/financiamentos/listar', { itensPorPagina: 100, ...params }).then(r => r.data),
  obter: (id: string) => api.get<Financiamento>(`/api/financiamentos/${id}`).then(r => r.data),
  criar: (data: DadosFinanciamento & { dataEntrada?: string; gerarLancamentoEntrada: boolean; anexoUrl?: string }) =>
    api.post<Financiamento>('/api/financiamentos', data).then(r => r.data),
  atualizar: (id: string, data: Partial<{
    accountId: string; categoriaId: string; descricao: string; instituicao: string
    valorTotal: number; valorEntrada: number; taxaJurosMensal: number; taxaJurosAnual: number
    sistemaAmortizacao: SistemaAmortizacao; anexoUrl: string; indiceCorrecao: IndiceCorrecaoMonetaria
    veiculoId: string; removerVeiculo: boolean
  }>) => api.put<Financiamento>(`/api/financiamentos/${id}`, data).then(r => r.data),
  /** apagarLancamentos: o que fazer com os lançamentos já pagos (true apaga e devolve o saldo; false mantém como despesas). */
  remover: (id: string, apagarLancamentos?: boolean) => api.delete(`/api/financiamentos/${id}`, { params: { apagarLancamentos } }),
  encerrar: (id: string) => api.post(`/api/financiamentos/${id}/encerrar`),
  quitar: (id: string, data: { valorQuitacao: number; data: string }) =>
    api.post<Financiamento>(`/api/financiamentos/${id}/quitar`, data).then(r => r.data),
  marcarParcelasPagasEmMassa: (id: string, data: { ate?: string; ateNumero?: number; dataPagamento?: string }) =>
    api.post<number>(`/api/financiamentos/${id}/parcelas/marcar-pagas-em-massa`, data).then(r => r.data),
  editarParcela: (id: string, parcelaId: string, data: { data?: string; valor?: number }) =>
    api.put<ParcelaFinanciamento>(`/api/financiamentos/${id}/parcelas/${parcelaId}`, data).then(r => r.data),
  pagarParcela: (id: string, parcelaId: string, data: { dataPagamento: string; desconto?: number; multa?: number }) =>
    api.post<ParcelaFinanciamento>(`/api/financiamentos/${id}/parcelas/${parcelaId}/pagar`, data).then(r => r.data),
  toggleLancamento: (id: string, parcelaId: string, gerarLancamento: boolean) =>
    api.put<ParcelaFinanciamento>(`/api/financiamentos/${id}/parcelas/${parcelaId}/gerar-lancamento`, { gerarLancamento }).then(r => r.data),
  simularAmortizacaoExtra: (id: string, data: { valorExtra: number; data: string; estrategia: EstrategiaAmortizacaoExtra }) =>
    api.post<AmortizacaoExtraResultado>(`/api/financiamentos/${id}/simular-amortizacao-extra`, data).then(r => r.data),
  aplicarAmortizacaoExtra: (id: string, data: { valorExtra: number; data: string; estrategia: EstrategiaAmortizacaoExtra }) =>
    api.post<Financiamento>(`/api/financiamentos/${id}/aplicar-amortizacao-extra`, data).then(r => r.data),
  corrigirManualmente: (id: string, data: { mes: number; ano: number; indiceValor: number }) =>
    api.put<Financiamento>(`/api/financiamentos/${id}/correcao-manual`, data).then(r => r.data),
  listarAmortizacoesExtras: (id: string) =>
    api.get<AmortizacaoExtraLancada[]>(`/api/financiamentos/${id}/amortizacao-extra`).then(r => r.data),
  editarAmortizacaoExtra: (id: string, transacaoId: string, data: { valor?: number; data?: string }) =>
    api.put<Financiamento>(`/api/financiamentos/${id}/amortizacao-extra/${transacaoId}`, data).then(r => r.data),
  removerAmortizacaoExtra: (id: string, transacaoId: string) =>
    api.delete<Financiamento>(`/api/financiamentos/${id}/amortizacao-extra/${transacaoId}`).then(r => r.data),
}

// ── Relatórios ────────────────────────────────────────────────────────────────
export const relatoriosApi = {
  porCategoria: (mes: number, ano: number) =>
    api.get<RelatorioCategorias>('/api/relatorios/categorias', { params: { mes, ano } }).then(r => r.data),
  porMes: (mes: number, ano: number, mesesHistorico = 12) =>
    api.get<{ itens: RelatorioMesItem[] }>('/api/relatorios/mensal', { params: { mes, ano, mesesHistorico } }).then(r => r.data.itens),
  categoriaHistorico: (categoriaIds: string[], tipo: TransactionType, anual: boolean, periodos?: number) =>
    api.get<RelatorioCategoriaHistorico>('/api/relatorios/categorias-historico', {
      params: { categoriaIds, tipo, anual, periodos },
      paramsSerializer: { indexes: null },
    }).then(r => r.data),
  projecao: (meses = 6) =>
    api.get<{ itens: RelatorioProjecaoItem[] }>('/api/relatorios/projecao', { params: { meses } }).then(r => r.data.itens),
  /** Barras do comparativo: alguns meses antes e depois de hoje, pelo caixa (realizado e previsto). */
  comparativo: (mesesAntes = 6, mesesDepois = 3) =>
    api.get<Comparativo>('/api/relatorios/comparativo', { params: { mesesAntes, mesesDepois } }).then(r => r.data),
  /** Lista do mês tocado no comparativo. A soma dos itens é o número da barra. */
  comparativoLancamentos: (mes: number, ano: number) =>
    api.get<ComparativoLancamentos>('/api/relatorios/comparativo/lancamentos', { params: { mes, ano } }).then(r => r.data),
  exportarCsv: (mes: number, ano: number) =>
    api.get<Blob>('/api/relatorios/exportar-csv', { params: { mes, ano }, responseType: 'blob' }).then(r => r.data),
}

// ── Insights ─────────────────────────────────────────────────────────────────
export const insightsApi = {
  patrimonioHistorico: (meses = 12) =>
    api.get<PatrimonioHistorico>('/api/insights/patrimonio-historico', { params: { meses } }).then(r => r.data),
  assinaturasDetectadas: () =>
    api.get<{ itens: AssinaturaDetectada[] }>('/api/insights/assinaturas-detectadas').then(r => r.data.itens),
  parcelasFuturas: () =>
    api.get<ParcelasFuturas>('/api/insights/parcelas-futuras').then(r => r.data),
  qualidadeCategorizacao: (meses = 6) =>
    api.get<QualidadeCategorizacao>('/api/insights/qualidade-categorizacao', { params: { meses } }).then(r => r.data),
}

// ── Veículos ─────────────────────────────────────────────────────────────────
export const veiculosApi = {
  /** Busca no catálogo (modelos da FIPE já cadastrados + os manuais do usuário). Sem `busca` (menos de 2 letras) vêm só os do próprio usuário. */
  modelos: (params?: { busca?: string; tipo?: TipoVeiculo }) =>
    api.get<ModeloVeiculo[]>('/api/veiculos/modelos', { params }).then(r => r.data),
  criarModeloFipe: (data: CriarModeloFipeRequest) =>
    api.post<ModeloFipeResultado>('/api/veiculos/modelos/fipe', data).then(r => r.data),
  criarModeloManual: (data: CriarModeloManualRequest) =>
    api.post<ModeloVeiculo>('/api/veiculos/modelos/manual', data).then(r => r.data),
  fipe: {
    marcas: (tipo: TipoVeiculo) =>
      api.get<FipeLista>('/api/veiculos/fipe/marcas', { params: { tipo } }).then(r => r.data),
    modelos: (marcaId: string, tipo: TipoVeiculo) =>
      api.get<FipeLista>(`/api/veiculos/fipe/marcas/${encodeURIComponent(marcaId)}/modelos`, { params: { tipo } }).then(r => r.data),
    anos: (modeloId: string, marcaId: string, tipo: TipoVeiculo) =>
      api.get<FipeLista>(`/api/veiculos/fipe/modelos/${encodeURIComponent(modeloId)}/anos`, { params: { marcaId, tipo } }).then(r => r.data),
  },
  cores: () => api.get<Cor[]>('/api/veiculos/cores').then(r => r.data),
  list: () => api.get<VeiculoResumo[]>('/api/veiculos').then(r => r.data),
  obter: (id: string) => api.get<Veiculo>(`/api/veiculos/${id}`).then(r => r.data),
  criar: (data: SalvarVeiculoRequest) => api.post<Veiculo>('/api/veiculos', data).then(r => r.data),
  atualizar: (id: string, data: SalvarVeiculoRequest) => api.put<Veiculo>(`/api/veiculos/${id}`, data).then(r => r.data),
  vender: (id: string, data: VenderVeiculoRequest) => api.post<Veiculo>(`/api/veiculos/${id}/vender`, data).then(r => r.data),
  registrarOdometro: (id: string, data: RegistrarOdometroRequest) =>
    api.post<RegistrarOdometroResultado>(`/api/veiculos/${id}/odometro`, data).then(r => r.data),
  /** Renova o valor FIPE se o guardado não for do mês atual (conta na cota da FIPE). */
  atualizarFipe: (id: string) => api.post<ValorFipeVeiculo>(`/api/veiculos/${id}/fipe/atualizar`).then(r => r.data),
  /** Abastecimentos (plano veiculos.abastecimento). `de`/`ate` são livres; o rendimento de cada item vem do histórico inteiro. */
  abastecimentos: {
    list: (id: string, params?: { de?: string; ate?: string }) =>
      api.get<Abastecimento[]>(`/api/veiculos/${id}/abastecimentos`, { params }).then(r => r.data),
    /** Com alerta de km responde `gravado = false` até reenviar com `confirmarRegressao`. */
    criar: (id: string, data: SalvarAbastecimentoRequest) =>
      api.post<SalvarAbastecimentoResultado>(`/api/veiculos/${id}/abastecimentos`, data).then(r => r.data),
    atualizar: (id: string, abastecimentoId: string, data: SalvarAbastecimentoRequest) =>
      api.put<SalvarAbastecimentoResultado>(`/api/veiculos/${id}/abastecimentos/${abastecimentoId}`, data).then(r => r.data),
    /** Apaga também o lançamento ligado (fatura já paga bloqueia com 409). */
    remover: (id: string, abastecimentoId: string) => api.delete(`/api/veiculos/${id}/abastecimentos/${abastecimentoId}`),
  },
  /** Consumo calculado pelo histórico (média, mediana, série, cidade x estrada, postos, último abastecimento). */
  consumo: (id: string, params?: { de?: string; ate?: string }) =>
    api.get<ConsumoVeiculo>(`/api/veiculos/${id}/consumo`, { params }).then(r => r.data),
  /** Despesas do veículo (IPVA, seguro, multa...). Geram o lançamento ligado. */
  despesas: {
    list: (id: string, params?: { de?: string; ate?: string }) =>
      api.get<DespesaVeiculo[]>(`/api/veiculos/${id}/despesas`, { params }).then(r => r.data),
    criar: (id: string, data: SalvarDespesaVeiculoRequest) =>
      api.post<DespesaVeiculo>(`/api/veiculos/${id}/despesas`, data).then(r => r.data),
    atualizar: (id: string, despesaId: string, data: SalvarDespesaVeiculoRequest) =>
      api.put<DespesaVeiculo>(`/api/veiculos/${id}/despesas/${despesaId}`, data).then(r => r.data),
    remover: (id: string, despesaId: string) => api.delete(`/api/veiculos/${id}/despesas/${despesaId}`),
  },
  /** Plano de manutenção do veículo (plano `veiculos.manutencao`): itens com previsão e status, catálogo típico e baixas. */
  manutencao: {
    itens: (id: string) => api.get<ItemManutencao[]>(`/api/veiculos/${id}/manutencao/itens`).then(r => r.data),
    criarItem: (id: string, data: SalvarItemManutencaoRequest) =>
      api.post<ItemManutencao>(`/api/veiculos/${id}/manutencao/itens`, data).then(r => r.data),
    atualizarItem: (id: string, itemId: string, data: SalvarItemManutencaoRequest) =>
      api.put<ItemManutencao>(`/api/veiculos/${id}/manutencao/itens/${itemId}`, data).then(r => r.data),
    removerItem: (id: string, itemId: string) => api.delete(`/api/veiculos/${id}/manutencao/itens/${itemId}`),
    /** Sugestões típicas para o tipo e a energia do veículo (com `jaExiste`). */
    catalogo: (id: string) => api.get<CatalogoManutencao>(`/api/veiculos/${id}/manutencao/catalogo`).then(r => r.data),
    /** Cria os itens escolhidos do catálogo (todos os que faltam, sem `nomes`); a contagem começa no km e na data de hoje. */
    carregarCatalogo: (id: string, data: CarregarCatalogoRequest = {}) =>
      api.post<ItemManutencao[]>(`/api/veiculos/${id}/manutencao/carregar-catalogo`, data).then(r => r.data),
  },
  /** Baixas de manutenção: geram o lançamento ligado e o km, e reiniciam a contagem do item. */
  manutencoes: {
    list: (id: string, params?: { de?: string; ate?: string }) =>
      api.get<RegistroManutencao[]>(`/api/veiculos/${id}/manutencoes`, { params }).then(r => r.data),
    criar: (id: string, data: SalvarRegistroManutencaoRequest) =>
      api.post<SalvarRegistroManutencaoResultado>(`/api/veiculos/${id}/manutencoes`, data).then(r => r.data),
    atualizar: (id: string, registroId: string, data: SalvarRegistroManutencaoRequest) =>
      api.put<SalvarRegistroManutencaoResultado>(`/api/veiculos/${id}/manutencoes/${registroId}`, data).then(r => r.data),
    /** Apaga também o lançamento ligado (fatura já paga bloqueia com 409). */
    remover: (id: string, registroId: string) => api.delete(`/api/veiculos/${id}/manutencoes/${registroId}`),
  },
  /** Próximos vencimentos: itens de manutenção e despesas com data (IPVA, seguro, licenciamento). */
  vencimentos: (id: string) => api.get<Vencimento[]>(`/api/veiculos/${id}/vencimentos`).then(r => r.data),
  /** Insights completos do período (plano `veiculos.insights`); sem `de`, desde o primeiro registro; sem `ate`, hoje. */
  insights: (id: string, params?: { de?: string; ate?: string }) =>
    api.get<InsightsVeiculo>(`/api/veiculos/${id}/insights`, { params }).then(r => r.data),
}

// ── Onboarding e tutoriais ────────────────────────────────────────────────────
export const onboardingApi = {
  obter: () => api.get<OnboardingInfo>('/api/onboarding').then(r => r.data),
  atualizar: (data: AtualizarOnboardingRequest) => api.put<OnboardingInfo>('/api/onboarding', data).then(r => r.data),
}

export const tutoriaisApi = {
  /** Liberação de cada recurso no plano do usuário e o menor plano que libera. */
  planos: () => api.get<TutoriaisPlanos>('/api/tutoriais/planos').then(r => r.data),
}
